export { default } from 'signer-app/parts/illustration-lockup/illustration-lockup';
